import { IMAGES } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative bg-[#0d281e] text-[#f1ede5]">
      {/* Full hoarding image — shown edge to edge, no text cut */}
      <div className="pt-20 md:pt-24">
        <img
          src={IMAGES.hero}
          alt="Valley Mills · Pudsey · Leeds — Coming Soon. Refurbished trade counter, industrial &amp; office units to let."
          className="w-full h-auto block"
        />
      </div>

      {/* Coming Early 2027 announcement band */}
      <div className="bg-[#b39352] text-[#0d281e] border-t border-[#0d281e]/15">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-8 md:py-10 flex flex-col md:flex-row md:items-center md:justify-center gap-4 text-center md:text-left">
          <div className="hidden md:block h-8 w-px bg-[#0d281e]/40" />
          <div className="text-[11px] tracking-[0.4em] font-semibold uppercase">Launching</div>
          <div className="hidden md:block h-8 w-px bg-[#0d281e]/40" />
          <div className="font-serif-display text-[38px] md:text-[52px] leading-none tracking-tight">
            Coming <em className="italic">Early 2027</em>
          </div>
          <div className="hidden md:block h-8 w-px bg-[#0d281e]/40" />
          <div className="text-[11px] tracking-[0.28em] font-medium uppercase md:max-w-[180px]">
            Register your interest today
          </div>
          <div className="hidden md:block h-8 w-px bg-[#0d281e]/40" />
        </div>
      </div>

      {/* Below-hoarding CTA strip */}
      <div className="bg-[#0d281e] border-t border-[#b39352]/40">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="max-w-xl">
            <div className="text-[11px] tracking-[0.3em] text-[#b39352] font-medium">
              A LANDMARK YORKSHIRE MILL
            </div>
            <p className="mt-3 font-serif-display text-[26px] md:text-[32px] leading-tight text-[#f1ede5]">
              Reimagined for <em className="italic text-[#b39352]">ambitious businesses.</em>
            </p>
          </div>
          <div className="flex items-center gap-8">
            <a href="#enquire" className="btn-gold">Enquire Now</a>
            <a href="#availability" className="btn-outline">View Availability</a>
          </div>
        </div>
      </div>
    </section>
  );
}
